const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxtCxyBW3GIq0xYXZMxy5
kQlzpFSrZcFQWbShKRIgellbDOXDXOqhiikxECbxrKdCNuYXaH305p2M3RRZtK1f
sdvLCP/u6cSz96+Oy5kdqnowNzSYkDhyerIcqzEXBJOqgEy8iIOeSsHKXNG8f90V
4i19APQDV8cfcrS5O71COTB9Dd9oALXLzJneqsRTksiSneUlkWWMrHoNX0HroGuq
gKKKqurPE+KCt6wpeESSsxT7TNOSAHDq1PgdeHZfdAxiaiyzNAWWMfGfIRBeMapt
ka6wKX25bdmW9xXLqODhS6alEYVG/eSz22MLu8Vas+CtvaGBeY5aD0cr8LnQDGc7
HQIDAQAB
-----END PUBLIC KEY-----`;

function pemToArrayBuffer(pem) {
    const b64 = pem
        .replace(/-----BEGIN PUBLIC KEY-----/, "")
        .replace(/-----END PUBLIC KEY-----/, "")
        .replace(/\s+/g, "");

    const binary = window.atob(b64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";

    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
}

function generateSecretToken() {
    const randomBytes = crypto.getRandomValues(new Uint8Array(16));

    const hex = Array.from(randomBytes, (byte) =>
        byte.toString(16).padStart(2, "0")
    ).join("");

    return `token-${crypto.randomUUID()}-${hex}`;
}

async function importPublicKey(pem) {
    const binary = pemToArrayBuffer(pem);

    return await crypto.subtle.importKey(
        "spki",
        binary,
        {
            name: "RSA-OAEP",
            hash: "SHA-256",
        },
        true,
        ["encrypt"]
    );
}

async function encryptSecret(secret, publicKey) {
    const encoder = new TextEncoder();
    const encoded = encoder.encode(secret);

    const encrypted = await crypto.subtle.encrypt(
        {
            name: "RSA-OAEP",
        },
        publicKey,
        encoded
    );

    return arrayBufferToBase64(encrypted);
}

export const getSecretToken = async () => {
    const secretKey = generateSecretToken();
    const publicKey = await importPublicKey(PUBLIC_KEY_PEM);
    const encryptedSecret = await encryptSecret(secretKey, publicKey);
    return encryptedSecret;
};